/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetType = {
    ADR: 'ADR',
    ETF: 'ETF',
    COMMON_STOCK: 'Common Stock',
    REORGANIZED_STOCK: 'Reorganized Stock',
    WHEN_ISSUED: 'When Issued',
    CORPORATE: 'Corporate',
    PREFERRED: 'Preferred',
    MUTUAL_FUND: 'Mutual Fund',
    WARRANT: 'Warrant',
    SPAC: 'SPAC',
    MUNI: 'Muni',
    TREASURY: 'Treasury',
    FUTURES: 'Futures',
    INDEX: 'Index',
    INTEREST_RATES: 'Interest Rates',
    VOLATILITY: 'Volatility',
    EQUITY: 'Equity',
    MBS: 'MBS',
    AGENCY: 'Agency',
    CERTIFICATE_OF_DEPOSIT: 'Certificate of Deposit',
    REIT: 'REIT',
    COMMODITIES: 'Commodities',
    OTHER: 'Other',
    PRIVATE: 'Private',
    CURRENCY: 'Currency',
    CHARITABLE_FUND: 'Charitable Fund'
} as const;
export type AssetType = typeof AssetType[keyof typeof AssetType];


export function instanceOfAssetType(value: any): boolean {
    for (const key in AssetType) {
        if (Object.prototype.hasOwnProperty.call(AssetType, key)) {
            if (AssetType[key as keyof typeof AssetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetTypeFromJSON(json: any): AssetType {
    return AssetTypeFromJSONTyped(json, false);
}

export function AssetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetType {
    return json as AssetType;
}

export function AssetTypeToJSON(value?: AssetType | null): any {
    return value as any;
}

export function AssetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetType {
    return value as AssetType;
}

